import { Button, Form, Header } from 'semantic-ui-react';
import styled from 'styled-components';

const DrawerContainer = styled.div`
  .drawer {
    background: #ffffff !important;
    border-top-right-radius: 1rem !important;
    width: 30% !important;
    padding: 0 1rem !important;
    position: fixed;
    min-width: 300px !important;
    .pushable:not(body) {
      transform: none;
    }
    z-index: 1000;
    background: #ffffff !important;
    .pushable:not(body) > .ui.sidebar,
    .pushable:not(body) > .fixed,
    .pushable:not(body) > .pusher:after {
      position: fixed;
    }
  }
`;

const DrawerHeader = styled.div`
  align-items: center;
  display: flex;
  .ui.header {
    font-size: 18px !important;
  }
`;

const DrawerTitle = styled(Header)`
  margin-right: auto;
  font-weight: bold;
`;

const DrawerAction = styled.div`
  margin-left: 0.75rem;
  position: relative;
`;

const DrawerActionClose = styled(Button)`
  background: transparent !important;
  padding: 0 !important;
  color: #1e293b !important;
  &:hover {
    background-color: initial !important;
  }
`;

const DrawerFooter = styled(Form.Field)`
  margin-top: 3rem !important;
  float: right;
`;

export const DrawerEl = {
  DrawerContainer,
  DrawerHeader,
  DrawerTitle,
  DrawerAction,
  DrawerActionClose,
  DrawerFooter
};
